import { CREATE_ORDER } from "./apiEndpoints";

export const createOrder = async (orderData) => {
  try {
    const res = await fetch(CREATE_ORDER, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderData),
    });

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`Order creation failed: ${errorText}`);
    }

    return await res.json();
  } catch (error) {
    console.error("Error in createOrder:", error);
    throw error;
  }
};
